import {
    Bonus,
    BonusType,
    Deduction,
    DeductionType,
} from "../../types/adjustments";

/** Separate earnings adjustments from post-tax loan cash flows. */
export const calculateAdjustments = (
    bonus: Bonus[],
    deduction: Deduction[]
) => {
    const sum = <T extends string>(
        items: { type: T; amount: number }[],
        regular: T,
        advance: T
    ) => {
        if (!Array.isArray(items))
            throw new RangeError("Adjustments must be arrays");
        let regularTotal = 0;
        let advanceTotal = 0;
        for (const item of items) {
            if (
                !item ||
                !Number.isFinite(item.amount) ||
                item.amount < 0 ||
                (item.type !== regular && item.type !== advance)
            )
                throw new RangeError(
                    "Adjustments require a valid type and finite nonnegative amount"
                );
            if (item.type === regular) regularTotal += item.amount;
            else advanceTotal += item.amount;
        }
        if (!Number.isFinite(regularTotal + advanceTotal))
            throw new RangeError("Adjustment totals must be finite");
        return [regularTotal, advanceTotal];
    };
    const [regularBonus, advances] = sum(
        bonus,
        BonusType.RegularBonus,
        BonusType.AdvancePayment
    );
    const [regularDeduction, repayments] = sum(
        deduction,
        DeductionType.RegularDeduction,
        DeductionType.AdvanceRepayment
    );
    return {
        earnings: regularBonus - regularDeduction,
        cash: advances - repayments,
    };
};
